export default __webpack_public_path__ + "static/media/btn-google-black-bg.0ec4c291.svg";